
import { computed, defineComponent } from "vue";

export default defineComponent({
  name: "InputDate",
  props: {
    value: { type: Date },
    disabled: { type: Boolean },
  },
  setup(props, context) {
    const date = computed({
      get: () => props.value,
      set: (newValue) => {
        context.emit("update:value", newValue);
      },
    });
    return {
      date,
    };
  },
});
